export default "__VITE_ASSET__DSXc_r2F__"